<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>物品使用申请单&nbsp;&nbsp;说明:</h5><br>
				<span>1、物品使用申请,也可以通过预设模板引入明细,减少编辑。</span><br>
				<span class="red">2、主要是针对耗材类的物品进行申请</span><br>
				<span class="red">3、查询关键字:业务单号、出仓名称、入仓名称、转移日期、车队</span><br>

			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="pre_base_button">
				<button @click="edit_mode">引入模板</button>
			</template> -->

		</pre-base>
		<!-- 
		<editmode-tan ref="itemmode"></editmode-tan> -->

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "store_apply",
					"title": "申请单",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_store_car_storeapply',
					"upd_action": 'exp15_store_car_storeapply',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "1",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": 'exp_store_car_storeapply_d',
					"d_upd_action": '_store_car_d_storeapply',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "申请仓库",
							"val": "",
							"key": "in_store",
							"type": "select",
							"class": "long2",
							"sel_action": "_base_storecar",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "申请日期",
							"val": "",
							"key": "in_date",
							"type": "date",
							"class": "long1"
						},
						// {
						//   "name": "部门",
						//   "val": "",
						//   "key": "d_name",
						//   "type": "select",
						//   "class": "long1",
						//   "weight": "1",
						//   "list": this.list_dep.data,
						//   "sel_val": {},
						//   "sel_name": "",
						//   "p": "1",
						//   "w": "1",
						//   "r": "0",
						//   "x": "1"
						// },
						{
							"name": "申请人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"weight": "1",
							"sel_action": "_base_alluser",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "车队",
							"val": "",
							"key": "team",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_teamname",
							"sel_name": ""
						}
					],
					"parm": [
						{
							"name": "业务编号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "申请仓库",
							"val": "",
							"key": "in_store",
							"type": "select",
							"class": "long2",
							"sel_action": "_base_storecar",
							"sel_name": "",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "申请日期",
							"val": "",
							"key": "in_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "总金额",
							"val": "",
							"key": "amount",
							"type": "number",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_dep",
							"sel_name": "",
							"sel_more": "1_to",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"weight": "1",
							"sel_action": "_base_alluser",
							"list":[],
							"sel_name": "",
							"sel_more": "1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "引入模板",
							"val": "",
							"key": "item_mode",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_itemmode",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "申请仓库"
						},
						{
							"name": "部门"
						},
						{
							"name": "申请人"
						},
						{
							"name": "总金额"
						},
						{
							"name": "申请日期"
						},
						{
							"name": "备注"
						},
						{
							"name": "明细"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [
						{
							"name": "业务编号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "物品编码",
							"val": "",
							"key": "item_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
						},
						{
							"name": "物品数量",
							"val": "",
							"key": "qty",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
						},
						// {
						//   "name": "单价",
						//   "val": "",
						//   "key": "price",
						//   "type": "number",
						//   "class": "long1",
						//   "p": "1",
						//   "w": "0",
						// },
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "编号"
						},
						{
							"name": "名称"
						},
						{
							"name": "规格"
						},
						{
							"name": "单位"
						},
						{
							"name": "数量"
						},
						{
							"name": "单价"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}
					]

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			// edit_mode: function() {

			// 	this.$refs.itemmode.showpop();
			// },



		}
	};
</script>
<style>
</style>
